<template>
    <template v-if="ready">
        <component :is="layout" v-bind="propsData"/>
    </template>
</template>

<script>
import {ref, shallowRef, watch} from "vue";
import {useRoute} from "vue-router";
import DefaultLayout from '@/layouts/default'

export default {
    name: "App",
    setup(props) {
        const layout = shallowRef('');
        const route = useRoute();
        let propsData = ref({});
        const ready = ref(false);

        watch(route, (curr,old) => {
            if (curr.meta.layout.component !== undefined) {
                layout.value = curr.meta.layout.component;
                propsData.value = curr.meta.layout.props;
            }
            else if (curr.meta.layout !== undefined) {
                layout.value = curr.meta.layout;
            } else {
                layout.value = DefaultLayout // this is default layout if route meta is not set
            }
            ready.value = true;

        });

        return {
            layout,
            propsData,
            ready,
        }
    }
}
</script>

<style lang="scss">
</style>
